<template>


  <a-drawer :title="title" :width="800" :visible="showYjqlForm" :body-style="{ paddingBottom: '80px' }" @close="close">

    
    <a-form-model
      ref="form"
      :model="model"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      >
        <a-spin :spinning="loading">
          <template>
            
            <div v-for="(row, index) in model.raise_info" :key="index" style="border:1px solid #cccccc;margin-top:0px;margin-bottom:40px;padding:10px">
              <a-row type="flex" style="margin-bottom:20px">
                <a-col flex="660px">
                  <a-tag color="orange">
                    起量方案 {{ index+1 }}
                  </a-tag>
                </a-col>
                <a-col flex="auto">
                  <a href="#" @click="deleteRow(index)">删除</a>
                </a-col>
              </a-row>
              
              <a-form-model-item label="起量预算" :prop="`raise_info[${index}].raise_budget`" help="" >
                <a-input-number style="width:100%" v-model="row.raise_budget" suffix="元" />
              </a-form-model-item>
    
              <a-form-model-item label="重复周期" :prop="`raise_info[${index}].repeat_type`" help=''>
                <a-radio-group v-model="row.repeat_type" >
                  <a-radio-button :value="item.id" v-for="item in repeat_types" :key="item.id">
                    {{ item.name }}
                  </a-radio-button>
                </a-radio-group>
              </a-form-model-item>
    
              <a-form-model-item label="起量时间" v-if="row.repeat_type==1" :prop="`raise_info[${index}].appoint_time.raise_time`" help="" >
                <a-date-picker
                  v-model="row.appoint_time.raise_time"
                  :show-time="{ format: 'HH:mm' }"
                  format="YYYY-MM-DD HH:mm"
                  placeholder="选择起量时间"
                  @change="(value) => handleDateChange(value, index)"
                />
              </a-form-model-item>

              <template v-if="row.repeat_type==2" >
                <a-form-model-item label="" :prop="`raise_info[${index}].appoint_time.repeat_day`" help="" style="margin-left:50px">
                  <byted-checkbox-group v-model="row.appoint_time.repeat_day" @change="onSelectDay(index, row.appoint_time.repeat_day)">
                    <byted-checkbox-button :val="item.key" v-for="item in repeat_days" :key="item.key" :single="item.is_single">{{item.name}}</byted-checkbox-button>
                  </byted-checkbox-group>
                </a-form-model-item>

                <a-form-model-item label="起量时间" :prop="`raise_info[${index}].appoint_time.raise_time`" help="" >
                  <a-time-picker
                    v-model="row.appoint_time.raise_time"
                    :format="'HH:mm'"
                    :value-format="'HH:mm'"
                    :default-value="row.appoint_time.raise_time"
                    placeholder="选择起量时间"
                  />
                </a-form-model-item>

              </template>
             

            </div>

          <!-- 新增按钮 -->
          <a-button @click="addRow" icon="plus-circle" style="width:750px">新增起量方案</a-button>

          </template>
        </a-spin>
      </a-form-model>

      <div :style="{
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e9e9e9',
        padding: '10px 16px',
        background: '#fff',
        textAlign: 'right',
        zIndex: 1,
      }">
        <a-button @click="close" :disabled="loading" :style="{ marginRight: '8px' }">
          取消
        </a-button>
        <a-button type="primary" @click="submit" :disabled="loading" :style="{ marginRight: '8px' }"> 确定 </a-button>
      </div>
  </a-drawer>
</template>

<style lang="less" scoped>
@import 'Yjql';
</style>

<script>
import Yjql from './Yjql'
export default Yjql
</script>
